import { StatusColor } from "~/constants/status"
import { StatusBadge } from "../reusable/StatusBadge"

const collectionStatusColor = (status: string) => {
  switch (status) {
    case "Active":
      return StatusColor.Success
    case "Upcoming":
      return StatusColor.Warning
    case "Expired":
      return StatusColor.Error
    default:
      return StatusColor.Neutral
  }
}

export default function CollectionStatus({ status }: { status: string }) {
  return <StatusBadge color={collectionStatusColor(status)} text={status} />
}
